import imgIconAppleDesktop3 from '../../../assets/images/compatible-browser/icon-apple-mobile@3x.png';
import imgIconAndroidDesktop3 from '../../../assets/images/compatible-browser/icon-google-mobile@3x.png';
import imgIconMacOSDesktop3 from '../../../assets/images/compatible-browser/icon-macos-desktop@3x.png';
import imgIconWindowsDesktop3 from '../../../assets/images/compatible-browser/icon-windows-desktop@3x.png';
import appConfig from '../../config/appConfig';
import * as localizationKeys from '../../consts/localization/localizationKeys';
import {getLocalizedStrings} from '../../services/localization/localizationService';

let data;

const getBrowserCompatibilityPageData = (availableContent, isBrowserCompatible) => {
    if (!data) {
        const localizedStrings = getLocalizedStrings();
        const {isAndroidContent, isIOSContent, isMacOSContent, isWindowsContent} = availableContent || {};

        if (isAndroidContent) {
            data = {
                link: appConfig.getLinkAndroidStoreIqos(),
                browserLink: appConfig.getLinkAndroidStoreChrome(),
                srcSet: [imgIconAndroidDesktop3],
                text: localizedStrings[localizationKeys.COMPATIBLE_BROWSER_PAGE_GOOGLE_BUTTON_TEXT],
                ariaLabel: isBrowserCompatible
                    ? localizedStrings[localizationKeys.APP_INTRO_PAGE_BTN_DOWNLOAD_ANDROID_OS_ARIA_LABEL]
                    : null,
            };
        } else if (isIOSContent) {
            data = {
                link: appConfig.getLinkIosStoreIqos(),
                browserLink: appConfig.getLinkIosStoreBluenet(),
                srcSet: [imgIconAppleDesktop3],
                text: localizedStrings[localizationKeys.COMPATIBLE_BROWSER_PAGE_APPLE_BUTTON_TEXT],
                ariaLabel: isBrowserCompatible
                    ? localizedStrings[localizationKeys.APP_INTRO_PAGE_BTN_DOWNLOAD_IOS_OS_ARIA_LABEL]
                    : null,
            };
        } else if (isMacOSContent) {
            data = {
                link: appConfig.getLinkMacWidget(),
                browserLink: appConfig.getLinkDesktopChrome(),
                srcSet: [imgIconMacOSDesktop3],
                text: localizedStrings[localizationKeys.COMPATIBLE_BROWSER_PAGE_MACOS_BUTTON_TEXT],
                ariaLabel: isBrowserCompatible
                    ? localizedStrings[localizationKeys.APP_INTRO_PAGE_BTN_DOWNLOAD_MAC_OS_ARIA_LABEL]
                    : null,
            };
        } else if (isWindowsContent) {
            data = {
                link: appConfig.getLinkWindowsWidget(),
                browserLink: appConfig.getLinkDesktopChrome(),
                srcSet: [imgIconWindowsDesktop3],
                text: localizedStrings[localizationKeys.COMPATIBLE_BROWSER_PAGE_WINDOWS_BUTTON_TEXT],
                ariaLabel: isBrowserCompatible
                    ? localizedStrings[localizationKeys.APP_INTRO_PAGE_BTN_DOWNLOAD_WINDOWS_OS_ARIA_LABEL]
                    : null,
            };
        }
    }

    return data;
};

export {getBrowserCompatibilityPageData};
